<section
  class="admin-create-blog-page"
  [class.is-rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="admin-page-head">
    <div>
      <span class="admin-badge">إدارة المدونة</span>
      <h1>إنشاء مقال جديد</h1>
      <p>أضف مقال جديد للمدونة مع العنوان، المحتوى، الصورة، وبيانات السيو.</p>
    </div>

    <button type="button" class="admin-refresh-btn" (click)="goBack()">
      رجوع لكل المقالات
    </button>
  </div>

  <div class="admin-state error" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="admin-state success" *ngIf="successMessage">
    {{ successMessage }}
  </div>

  <form class="create-blog-card" [formGroup]="blogForm" (ngSubmit)="submitBlog()">
    <div class="form-section">
      <div class="section-head">
        <span>01</span>
        <div>
          <h2>بيانات المقال الأساسية</h2>
          <p>اكتب العنوان، التصنيف، وقت القراءة، وحالة النشر.</p>
        </div>
      </div>

      <div class="form-grid">
        <label>
          <span>العنوان بالإنجليزي *</span>
          <input
            type="text"
            formControlName="title_en"
            placeholder="How to build a strong CV"
          />
          <small class="field-error" *ngIf="isInvalid('title_en')">
            العنوان بالإنجليزي مطلوب
          </small>
        </label>

        <label>
          <span>العنوان بالعربي *</span>
          <input
            type="text"
            formControlName="title_ar"
            placeholder="إزاي تعمل CV قوي"
          />
          <small class="field-error" *ngIf="isInvalid('title_ar')">
            العنوان بالعربي مطلوب
          </small>
        </label>

        <label>
          <span>Slug</span>
          <input
            type="text"
            formControlName="slug"
            placeholder="how-to-build-a-strong-cv"
          />
        </label>

        <label>
          <span>التصنيف *</span>
          <select formControlName="category" (change)="onCategoryChange($event)">
            <option *ngFor="let category of categories" [value]="category.value">
              {{ category.label }}
            </option>
          </select>
        </label>

        <label>
          <span>اسم التصنيف بالإنجليزي</span>
          <input type="text" formControlName="category_en" />
        </label>

        <label>
          <span>اسم التصنيف بالعربي</span>
          <input type="text" formControlName="category_ar" />
        </label>

        <label>
          <span>الأيقونة</span>
          <input type="text" formControlName="icon" placeholder="📄" />
        </label>

        <label>
          <span>تاريخ النشر</span>
          <input type="date" formControlName="published_at" />
        </label>

        <label>
          <span>وقت القراءة بالإنجليزي</span>
          <input type="text" formControlName="read_time_en" placeholder="5 min read" />
        </label>

        <label>
          <span>وقت القراءة بالعربي</span>
          <input type="text" formControlName="read_time_ar" placeholder="٥ دقائق قراءة" />
        </label>

        <label>
          <span>الحالة</span>
          <select formControlName="status">
            <option value="published">منشور</option>
            <option value="draft">مسودة</option>
          </select>
        </label>

        <label class="checkbox-label">
          <input type="checkbox" formControlName="is_featured" />
          <span>مقال مميز</span>
        </label>
      </div>
    </div>

    <div class="form-section">
      <div class="section-head">
        <span>02</span>
        <div>
          <h2>صورة المقال</h2>
          <p>ارفع صورة واضحة للمقال. الحد الأقصى 4MB.</p>
        </div>
      </div>

      <div class="image-upload-box">
        <div class="image-preview" *ngIf="imagePreviewUrl">
          <img [src]="imagePreviewUrl" alt="Blog preview" />
        </div>

        <div class="image-placeholder" *ngIf="!imagePreviewUrl">
          <strong>اضغط لاختيار صورة</strong>
          <small>jpg / png / webp / gif</small>
        </div>

        <input type="file" accept="image/*" (change)="onImageSelected($event)" />
      </div>

      <button
        type="button"
        class="secondary-btn remove-image-btn"
        *ngIf="selectedImageFile"
        (click)="removeSelectedImage()"
      >
        إزالة الصورة
      </button>
    </div>

    <div class="form-section">
      <div class="section-head">
        <span>03</span>
        <div>
          <h2>ملخص ومحتوى المقال</h2>
          <p>اكتب الملخص والمحتوى باللغتين. المحتوى يمكن أن يكون HTML.</p>
        </div>
      </div>

      <div class="form-grid">
        <label class="full">
          <span>الملخص بالإنجليزي</span>
          <textarea
            rows="4"
            formControlName="excerpt_en"
            placeholder="Learn how to prepare a professional CV."
          ></textarea>
        </label>

        <label class="full">
          <span>الملخص بالعربي</span>
          <textarea
            rows="4"
            formControlName="excerpt_ar"
            placeholder="اتعلم تجهز سيرة ذاتية احترافية."
          ></textarea>
        </label>

        <label class="full">
          <span>المحتوى بالإنجليزي HTML</span>
          <textarea
            rows="8"
            formControlName="content_en"
            placeholder="<p>Full English article content...</p>"
          ></textarea>
        </label>

        <label class="full">
          <span>المحتوى بالعربي HTML</span>
          <textarea
            rows="8"
            formControlName="content_ar"
            placeholder="<p>محتوى المقال العربي كامل...</p>"
          ></textarea>
        </label>

        <label>
          <span>Tags بالإنجليزي</span>
          <input
            type="text"
            formControlName="tags_en"
            placeholder="CV, Keywords, Jobs"
          />
        </label>

        <label>
          <span>Tags بالعربي</span>
          <input
            type="text"
            formControlName="tags_ar"
            placeholder="السيرة الذاتية, الكلمات المفتاحية, الوظائف"
          />
        </label>
      </div>
    </div>

    <div class="form-section">
      <div class="section-head">
        <span>04</span>
        <div>
          <h2>بيانات السيو</h2>
          <p>أضف عنوان ووصف لمحركات البحث باللغتين.</p>
        </div>
      </div>

      <div class="form-grid">
        <label>
          <span>Meta Title بالإنجليزي</span>
          <input type="text" formControlName="meta_title_en" />
        </label>

        <label>
          <span>Meta Title بالعربي</span>
          <input type="text" formControlName="meta_title_ar" />
        </label>

        <label class="full">
          <span>Meta Description بالإنجليزي</span>
          <textarea rows="3" formControlName="meta_description_en"></textarea>
        </label>

        <label class="full">
          <span>Meta Description بالعربي</span>
          <textarea rows="3" formControlName="meta_description_ar"></textarea>
        </label>
      </div>
    </div>

    <div class="form-actions">
      <button type="button" class="secondary-btn" (click)="resetForm()">
        تفريغ البيانات
      </button>

      <button type="submit" class="primary-btn" [disabled]="isSubmitting">
        {{ isSubmitting ? 'جاري إنشاء المقال...' : 'إنشاء المقال' }}
      </button>
    </div>
  </form>
</section>